export const CustomisationMixin = {
  computed: {
    customisation() {
      if (!this.widgetOptions) {
        return {};
      }
      const options = {};
      const arrayOptions = this.widgetOptions.split(";");

      for (const option of arrayOptions) {
        const keyValue = option.split("=");
        options[keyValue[0]] = this.evalOptionValue(keyValue[1]);
      }

      return options;
    }
  },

  methods: {
    evalOptionValue(value) {
      if (value === undefined) {
        return null;
      } else if (value === "true") {
        return true;
      } else if (value === "false") {
        return false;
      } else {
        return value;
      }
    }
  }
};
